/**
 * 郵便番号関係処理
 */
export default class Postcode {
  constructor(){
    this.convertInput();
  }
  convertInput(){
    function convertInputNumber(e) {
      let val = this.value;
      // 全角数字を半角数字に変換
      val = val.replace(/[０-９]/g, function (s) {
        return '０１２３４５６７８９'.indexOf(s);
      });
      // 半角数字以外を除去
      val = val.replace(/[^0-9]/g, '');
      this.value = val;
    }
    $(document).on('blur', '.js-postcode', convertInputNumber);
  }
}
